// CustomMapLayer.tsx
import { useMap } from "react-leaflet";
import { useEffect } from "react";
// @ts-ignore
import "leaflet.heat";
import * as L from "leaflet";
import "../shared/Heatmap.css";

export interface HeatPoint {
  lat: number;
  lng: number;
  intensity?: number;
}

interface Props {
  points: HeatPoint[];
  radius?: number;
  blur?: number;
  max?: number;
  gradient?: { [key: number]: string };
}

const CustomMapLayer: React.FC<Props> = ({
  points,
  radius = 25,
  blur = 15,
  max = 1.0,
  gradient,
}) => {
  const map = useMap();

  useEffect(() => {
    const heatData = points?.map((p) => [p.lat, p.lng, 1]);
   
    if (heatData && heatData.length > 0) {
       // @ts-ignore
      const heatLayer = L.heatLayer(heatData, { radius, blur, max, gradient }).addTo(map);

      return () => {
        map.removeLayer(heatLayer);
      };
    }

  }, [map, points, radius, blur, max, gradient]);

  return null;
};

export default CustomMapLayer;
